(() => {
  if (window.__metaxNewestProductsInstalled) return;
  window.__metaxNewestProductsInstalled = true;
  const init = async (section) => {
    if (section.dataset.newestStatus) return;
    const track = section.querySelector('.metax-products__track');
    const limit = Number(section.dataset.brandLimit);
    if (!track || !section.dataset.collectionUrl || !Number.isInteger(limit) || limit < 1) return;
    section.dataset.newestStatus = 'loading';
    const selected = new Map();
    const visited = new Set();
    let url = new URL(section.dataset.collectionUrl, window.location.origin);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    try {
      while (url && selected.size < limit) {
        if (!section.isConnected) return;
        if (url.origin !== window.location.origin) throw new Error('Invalid collection origin');
        url.searchParams.set('sort_by', 'created-desc');
        url.searchParams.set('section_id', 'metax-newest-products');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        if (visited.has(url.href)) throw new Error('Repeated collection page');
        visited.add(url.href);
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        let html;
        try {
          const response = await fetch(url.href, { signal: controller.signal });
          if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
          html = await response.text();
        } finally { clearTimeout(timer); }
        const page = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-metax-newest-page]');
        if (!page || page.dataset.sort !== 'created-desc') throw new Error('Missing newest-first collection data');
        for (const item of page.querySelectorAll('[data-metax-vendor]')) {
          const vendor = item.dataset.metaxVendor;
          if (!selected.has(vendor)) selected.set(vendor, item);
          if (selected.size >= limit) break;
        }
        url = page.dataset.nextUrl ? new URL(page.dataset.nextUrl, url) : null;
        if (!url && selected.size < limit && Number(page.dataset.total) > 25000) {
          throw new Error('Collection exceeds Shopify pagination limit');
        }
      }
      if (!section.isConnected) return;
      track.replaceChildren(...selected.values());
      section.dataset.newestStatus = 'complete';
    } catch (error) {
      // Leave the original server-rendered cards usable on timeout/render failure.
      section.dataset.newestStatus = 'fallback';
      console.warn('Metax newest-products: retaining fallback cards', error);
    }
  };
  const mount = (root = document) => {
    root.querySelectorAll('[data-metax-newest-products]').forEach(init);
  };
  mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
